"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = exports.Main = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position                  : fixed;\n  top                       : 0;\n  width                     : 100%;\n  z-index: 2;\n  background:\n    linear-gradient(\n      to right, \n      ", " 0%,\n      ", "\n    )\n    left \n    bottom\n    ", "    \n    no-repeat; \n  background-size:100% 1px ;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 64px;\n"])), _palette.palette.primary, _palette.palette.white, _palette.palette.white);

exports.Container = Container;
Container.displayName = 'Container';

var Main = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  width: 100%;\n  max-width: ", ";\n  padding-left: 20px;\n  padding-right: 20px;\n"])), function (props) {
  return props.maxWidth;
});

exports.Main = Main;
Main.displayName = 'Main';

var Column = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  &:nth-child(2) {\n    justify-content: center;\n  }\n  &:nth-child(3) {\n    justify-content: flex-end;\n  }\n"])));

exports.Column = Column;
Column.displayName = 'Column';